module.exports = __webpack_public_path__ + "img/brackets-ellipses.6b44902a.svg";